// Notifikace a push zařízení (docs/SPEC.md 2.8, 2.10).
import type {
  DigestTestResponse,
  NotificationPrefs,
  PushDevice,
  PushSubscriptionInput,
  UpdateNotificationPrefsInput,
  VapidResponse,
} from '@wac-buddy/shared'
import { api } from './client'

export function getNotificationPrefs(): Promise<NotificationPrefs> {
  return api('/me/notifications')
}

export function updateNotificationPrefs(
  input: UpdateNotificationPrefsInput,
): Promise<NotificationPrefs> {
  return api('/me/notifications', { method: 'PATCH', body: JSON.stringify(input) })
}

export function getVapidKey(): Promise<VapidResponse> {
  return api('/push/vapid')
}

export async function listPushDevices(): Promise<PushDevice[]> {
  const res = await api<{ data: PushDevice[] }>('/push/subscriptions')
  return res.data
}

export function createPushSubscription(input: PushSubscriptionInput): Promise<PushDevice> {
  return api('/push/subscriptions', { method: 'POST', body: JSON.stringify(input) })
}

export function deletePushSubscription(id: string): Promise<void> {
  return api(`/push/subscriptions/${encodeURIComponent(id)}`, { method: 'DELETE' })
}

export function sendDigestTest(): Promise<DigestTestResponse> {
  return api('/me/notifications/digest-test', { method: 'POST', body: JSON.stringify({}) })
}
